// Main JavaScript entry point
console.log("Clube da Consulta theme loaded successfully");

/**
 * Mobile Submenu Accordion Logic
 */
(function () {
	document.addEventListener("DOMContentLoaded", () => {
		const submenuParents = document.querySelectorAll(
			".header__nav .menu-item-has-children",
		);

		if (!submenuParents.length) return;

		// SVG Seta embutida do Design System
		const chevronSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>`;

		submenuParents.forEach((parent) => {
			const link = parent.querySelector("a"); // Primary link (e.g. "O Clube")

			// Create a button specifically for toggling
			const toggleBtn = document.createElement("button");
			toggleBtn.className = "mobile-submenu-toggle";
			toggleBtn.innerHTML = chevronSVG;
			toggleBtn.setAttribute("aria-expanded", "false");
			toggleBtn.setAttribute("aria-label", "Abrir submenu");

			// Insert button right after the link inside the wrapper (or directly in li)
			if (link.nextSibling) {
				parent.insertBefore(toggleBtn, link.nextSibling);
			} else {
				parent.appendChild(toggleBtn);
			}

			// Click Event
			toggleBtn.addEventListener("click", (e) => {
				e.preventDefault();
				const isMobile = window.innerWidth < 1024; // Check if LG breakpoint (match the SCSS)

				if (isMobile) {
					const isOpen = parent.classList.contains("is-open");

					// Fechar todos os abertos no mesmo nível (Opcional, mas boa UX)
					submenuParents.forEach((sibling) => {
						sibling.classList.remove("is-open");
						const btn = sibling.querySelector(".mobile-submenu-toggle");
						if (btn) btn.setAttribute("aria-expanded", "false");
					});

					// Toggle atual
					if (!isOpen) {
						parent.classList.add("is-open");
						toggleBtn.setAttribute("aria-expanded", "true");
					}
				}
			});
		});
	});
})();
